import { useEffect, useRef } from 'react';

const useOnUpdate = (callback, dependencies) => {
    const isPristine = useRef(true);

    useEffect(() => {
        if (isPristine.current) {
            isPristine.current = false;
        } else {
            callback();
        }
    }, dependencies);
};

export default useOnUpdate;
